var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle2, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFishBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#00edff",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M378 159L72 288l221 221a256 256 0 00217-218z",
    fill: "#0ac0ea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M404 192s-24-53-96-66-42 54-42 54z",
    fill: "#ed2415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320 185s-42-40-114-23-17 66-17 66z",
    fill: "#ed2415"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M403 312s-21 54-93 71-45-52-45-52z",
    fill: "#cc1611"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320 323s-41 42-114 30-20-66-20-66z",
    fill: "#cc1611"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294 154c-56 0-106 24-141 62-15-6-32-10-43-10a50 50 0 000 100c11 0 28-4 43-10a190 190 0 00309-40c-32-60-95-102-168-102z",
    fill: "#ff6155"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61 256c0 27 22 50 49 50 11 0 28-4 43-10a190 190 0 00309-40H61z",
    fill: "#ed2415"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87 256c0-23 16-43 38-48l-15-2a50 50 0 000 100l15-2c-22-5-38-25-38-48z",
    fill: "#333940"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61 256c0 27 22 50 49 50l15-2c-22-5-38-25-38-48z",
    fill: "#23272b"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M343 256c0-33 7-64 21-88-12-5-25-9-39-11-14 29-22 63-22 99s8 70 22 99c14-2 27-6 39-11-14-24-21-55-21-88z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M303 256c0 36 8 70 22 99 14-2 27-6 39-11-14-24-21-55-21-88h-40z",
    fill: "#e9edf5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M239 256c0 32-7 62-21 86l39 12c14-28 22-62 22-98s-8-69-22-98l-39 12c14 24 21 54 21 86z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239 256c0 32-7 62-21 86l39 12c14-28 22-62 22-98z",
    fill: "#e9edf5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165 205l-12 11c-9-4-19-6-28-8v96c9-2 19-4 28-8l12 11z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125 256v48c9-2 19-4 28-8l12 11v-51z",
    fill: "#e9edf5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.1,
    cy: 227.2,
    fill: "#333940",
    r: 12.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M307 317c-12 11-24 5-35-7-12-12-19-24-7-35s48-29 59-18c12 12-5 48-17 60z",
    fill: "#ed2415"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M299 256c-13 4-28 12-34 19-12 11-5 23 7 35 11 12 23 18 35 7s29-48 17-60l-1-1z",
    fill: "#cc1611"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishBadge);
export default __webpack_public_path__ + "static/media/fish-badge.5e759115f137159e4ad393cd28090e25.svg";
export { ForwardRef as ReactComponent };